import React from "react";
import classes from "./index.module.css";
import CourseCard from "../../../components/CourseCard";
import useEmblaCarousel from "embla-carousel-react";
import { useState } from "react";
import { useEffect } from "react";
import { UserModuleService } from "../../../services/userModuleService";
import { useLoader } from "../../../hooks";
import { toast } from "react-toastify";

const AvailableCourses = () => {
  const [startLoader, stopLoader] = useLoader();
  const [modules, setModules] = useState([]);
  const [emblaRef] = useEmblaCarousel({ align: "start" });

  useEffect(() => {
    UserModuleService.GetAvailableModules(
      {},
      () => startLoader("getModuleInfo"),
      handleSuccess,
      handleError,
      () => stopLoader("getModuleInfo")
    );
  }, []);

  const handleSuccess = ({ data }) => {
    if (Array.isArray(data.data)) {
      setModules(data.data);
    }
  };

  const handleError = (err) => {
    let data = err && err.response ? err.response.data : null;
    if (data) toast.error(data.message);
    else toast.error("Internal server error!");
  };

  return (
    <div className={classes.SectionContainer} id="available">
      <div className={classes.SectionHeader}>
        <div>
          <p className={classes.SectionTitle}>All Modules</p>
        </div>
        <div>
          {/* <button className={classes.TopBannerButton}>View All</button> */}
        </div>
      </div>

      {modules.length ? (
        <div className="embla">
          <div className="embla__viewport" ref={emblaRef}>
            <div className="embla__container">
              {modules.map((item, index) => (
                <div className="embla__slide" key={index}>
                  <CourseCard data={item} />
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className={classes.EmptyModule}>No Modules Available</div>
      )}
    </div>
  );
};

export default AvailableCourses;
